import { Box, Typography } from "@mui/material";
import React from "react";
import { commonCss } from "../../CssStyle/commonCss";

const PrivacyPolicy = () => {
  return (
    <Box
      sx={{
        p: { xs: "8rem 1rem 1rem 1rem", md: "8rem 3rem 3rem 3rem" },
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
        maxWidth: { xs: "auto", xl: "2000px" },
      }}
    >
      <Box>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "2.5rem",
            textAlign: "center",
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Privacy Policy
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: "2.2rem",
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Your privacy is critically important to us.
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          Our website address is: https://www.solverthoughts.com
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          Solver Thoughts Technologies Sdn Bhd is located at:
          <br />
          BO1-A-09-01, MENARA 2,
          <br />
          KL ECO CITY , 3, Jln BANGSAR 59200
          <br />
          KUALA LUMPUR
          <br />
          MALAYSIA
          <br />
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          At Solver Thoughts Technologies Sdn Bhd, we deeply value your privacy
          and are unwavering in our commitment to safeguarding any personally
          identifiable information you entrust to us through our website. This
          Privacy Policy serves as a transparent guide, detailing the types of
          information we collect, the purposes behind its use, and the specific
          circumstances under which we may disclose it to third parties. It's
          important to note that this policy exclusively pertains to information
          gathered through our website and does not include data obtained from
          other sources.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Website users
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          Solver Thoughts Technologies Sdn Bhd collects non-personally
          identifiable information, such as browser type, language preference,
          referring site, and the date and time of each visitor request, to
          understand how visitors use our website. We may release aggregated
          non-personally identifying information, like publishing reports on
          website usage trends.{" "}
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          Additionally, we collect potentially personally identifying
          information, including Internet Protocol (IP) addresses, for logged-in
          users and commenters on our blog posts. We disclose such information
          only under the same circumstances as described below for personally
          identifying information.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Information Gathering
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          Visitors to Solver Thoughts Technologies Sdn Bhd's websites may choose
          to engage in activities that require us to collect personally
          identifiable information. The specific information gathered varies
          based on the nature of the interaction. For instance, when visitors
          register for our blog at https://blog.solverthoughts.com, we request a
          username and email address.
        </Typography>
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Collection of Contact Information
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          We may collect contact information from users to enhance the
          functionality and user experience of our services. This data is
          securely stored and used exclusively for purposes outlined in our
          Privacy Policy. We do not share or use this information for any other
          purposes.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Use of Collected Contact Information
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          We collect contact information from users exclusively to enhance the
          functionality and user experience of our services. This data is
          securely stored and utilized solely for the purposes outlined in our
          Privacy Policy under the "Collection of Contact Information" section.
          We do not share or use this information for any other purposes without
          obtaining explicit consent from users.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Security
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          When you leave a comment on our site, you have the option to save your
          name, email address, and website in cookies. These cookies are
          designed for your convenience, eliminating the need to re-enter your
          details for subsequent comments. By default, these cookies will
          persist for one year.
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          We prioritize the security of your personal information. However, it's
          important to acknowledge that no method of transmission over the
          Internet, or method of electronic storage, is entirely secure. While
          we strive to employ commercially acceptable means to protect your
          personal information, we cannot guarantee its absolute security.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Advertisements
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          Ads appearing on our website may be delivered to users by advertising
          partners, who may set cookies. These cookies allow the ad server to
          recognize your computer each time they send you an online
          advertisement, compiling information about you or others who use your
          computer. This information enables ad networks to deliver targeted
          advertisements that they believe will be of most interest to you.
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          This Privacy Policy covers the use of cookies by Solver Thoughts
          Technologies Sdn Bhd and does not extend to the use of cookies by any
          advertisers. For more detailed information on how advertisers use
          cookies and how you can manage your cookie preferences, please refer
          to our Cookie Policy.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Links to External sites
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          Our website may contain links to external sites not operated by Solver
          Thoughts Technologies Sdn Bhd. If you click on a third-party link, you
          will be directed to that third party's site. We strongly advise you to
          review the Privacy Policy and terms and conditions of every site you
          visit.
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          We have no control over, and assume no responsibility for, the
          content, privacy policies, or practices of any third-party sites,
          products, or services.
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          This section clarifies our position regarding external links and
          encourages users to be mindful of the privacy practices of other
          websites they visit.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          SolverThoughts.com Uses Google AdWords for Remarketing Ads
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          SolverThoughts.com utilizes remarketing services to display ads on
          third-party websites, including Google, to individuals who have
          previously visited our site. This may involve targeting visitors who
          haven’t completed certain actions, such as filling out our contact
          form. These ads may appear on Google’s search results or across the
          Google Display Network. Third-party vendors, including Google, use
          cookies to show ads based on users’ past site visits. All data
          collected is handled according to our privacy policy as well as
          Google's privacy policy.
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          You have the option to manage your ad preferences through the Google
          Ad Preferences page. Additionally, you can choose to opt out of
          interest-based advertising altogether, either by adjusting your cookie
          settings or by using a browser plugin.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Safeguarding Your Personal Information
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          Solver Thoughts Technologies Sdn Bhd only shares potentially
          personally-identifying and personally-identifying information with its
          employees, contractors, and affiliated organizations who (i) need
          access to that information in order to process it on behalf of Solver
          Thoughts Technologies Sdn Bhd or provide services on the website, and
          (ii) have agreed not to disclose it to others. Some of these
          individuals or organizations may be based outside your home country;
          by using Solver Thoughts Technologies Sdn Bhd’s website, you consent
          to the transfer of such information to them. Solver Thoughts
          Technologies Sdn Bhd will never rent or sell personally-identifying or
          potentially identifying information to third parties. Aside from
          employees, contractors, and affiliated organizations, Solver Thoughts
          Technologies Sdn Bhd will only disclose this information in response
          to a subpoena, court order, governmental request, or when it believes
          in good faith that disclosure is necessary to protect its own property
          or rights, those of third parties, or the public.
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          If you are a registered user of https://blog.solverthoughts.com and
          have provided your email address, Solver Thoughts Technologies Sdn Bhd
          may occasionally send you emails about new features, request feedback,
          or update you on company developments. However, we mainly use our blog
          to communicate these updates, so we aim to keep such emails to a
          minimum. If you send us a request (such as through support emails or
          feedback forms), we may publish it to clarify or respond to your
          query, or to assist other users. Solver Thoughts Technologies Sdn Bhd
          takes all reasonable precautions to protect against unauthorized
          access, use, alteration, or destruction of personally-identifying
          information.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Aggregated Statistics
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          Solver Thoughts Technologies Sdn Bhd may gather statistics regarding
          the activities of visitors to its website. This data may be shared
          publicly or with third parties for analysis. However, any
          personally-identifying information remains confidential and will not
          be disclosed.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Affiliate Disclosure
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          This site contains affiliate links, and we may earn a commission from
          qualifying purchases. This has no impact on the price you pay.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Cookies
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          To enhance your online experience, Solver Thoughts Technologies Sdn
          Bhd uses cookies and similar technologies, along with services
          provided by third parties, to display personalized content, relevant
          ads, and to store your preferences on your device.
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          {" "}
          A cookie is a small piece of data that a website saves on a visitor's
          computer, which is then sent back to the website whenever the visitor
          returns. Solver Thoughts Technologies Sdn Bhd uses cookies to track
          and identify visitors, monitor their usage of
          https://blog.solverthoughts.com, and record their website preferences.
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          If you prefer not to have cookies stored on your device, you can
          configure your browser to reject cookies before using Solver Thoughts
          Technologies Sdn Bhd’s websites. However, please note that some
          features of the site may not function properly without cookies.
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          {" "}
          By continuing to use our website without changing your cookie
          settings, you consent to the use of cookies by Solver Thoughts
          Technologies Sdn Bhd.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          E-commerce
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          When engaging in transactions with Solver Thoughts Technologies Sdn
          Bhd, such as purchasing services or products, individuals may be asked
          to provide additional information, including personal and financial
          details required to complete the transaction. Solver Thoughts
          Technologies Sdn Bhd collects this information only to the extent
          necessary to fulfill the purpose of the visitor’s interaction.
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          {" "}
          Solver Thoughts Technologies Sdn Bhd does not share
          personally-identifying information except as outlined in this policy.
          Visitors have the option to decline providing personally-identifying
          information, but doing so may limit their ability to participate in
          certain activities on the website.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Business Transfers
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          In the event that Solver Thoughts Technologies Sdn Bhd is acquired, or
          if it goes out of business or enters bankruptcy, user information may
          be one of the assets transferred or acquired by a third party. By
          using the services, you acknowledge that such transfers may take
          place, and that any acquiring party may continue to use your personal
          information in accordance with this policy.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Families Policy
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          Solver Thoughts Technologies Sdn Bhd’s apps are designed to be safe
          and provide high-quality content, offering a platform where parents
          can share valuable knowledge with their children. The apps are
          child-friendly, featuring well-implemented APIs and SDKs. Solver
          Thoughts Technologies ensures that any ads shown are suitable for
          children and that any collection of personal or sensitive information
          is transparently disclosed within the app. Additionally, Solver
          Thoughts Technologies Sdn Bhd is committed to fully complying with all
          relevant legal regulations and standards concerning advertising to
          children.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Privacy Policy Changes
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          While most changes are expected to be minor, Solver Thoughts
          Technologies Sdn Bhd may update its Privacy Policy periodically at its
          discretion. We encourage visitors to review this page regularly to
          stay informed of any updates. Continued use of the site after any
          changes to the Privacy Policy will signify your acceptance of those
          changes.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{
            fontWeight: commonCss.subHeaderFontWeight,
            fontSize: commonCss.subHeaderFontSize,
            fontFamily: commonCss.headerFontFamilyPolicy,
          }}
        >
          Contact Information
        </Typography>
        <Typography
          variant={commonCss.contentVariant}
          sx={{
            fontWeight: commonCss.contentFontWeight,
            fontSize: commonCss.contentFontSize,
            fontFamily: commonCss.fontFamilyPolicy,
          }}
        >
          If you have any questions regarding this Privacy Policy, please feel
          free to reach out to us at info@solverthoughts.com.
        </Typography>
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;
